'use client';

import { Title } from '@/components/atoms/Title/Title';

import Stack from '@mui/material/Stack';
import { sp } from '@/theme/mui';
import { ResultList } from './ResultList';
import { useContext } from 'react';
import { DirectoryInteractionsContext } from '@/contexts/DirectoryInteractions';
import { GetMoreResultsButton } from './GetMoreResultsButton';
import { CareType } from '@/directory/types';
import { caresourcerHomeUrl } from '@/directory/constants';

const titleCase = (name?: string) =>
  name
    ?.split(/[\s-]+/)
    ?.map(
      (x: any) => `${x?.[0]?.toUpperCase() || ''}${x.substring(1) || '' || ''}`,
    )
    ?.join(' ');

const careLabel = (careType: any) => {
  return (
    (
      {
        care_home: 'care homes',
        home_care: 'home care agencies',
        care_home_dementia: 'dementia care homes',
      } as any
    )[careType || ''] || 'care providers'
  );
};

interface CareProviderSearchResultsProps {
  results?: any;
  variant?: 'long';
  buttonText?: string;
}
export const CareProviderSearchResults = ({
  results,
  variant,
  buttonText,
}: CareProviderSearchResultsProps) => {
  const { results: clientResults, request } = useContext(
    DirectoryInteractionsContext,
  );

  const response = clientResults || results;
  const { items } = response || {};

  const hasSearched = !!(request?.searchTerm || results);
  const searchReturnedNoResults = hasSearched && (!items || items.length === 0);
  const locationName = response?.req?.searchTerm || '';

  // error and loading
  const isError = false;
  return (
    <Stack sx={{ gap: sp[24], pt: sp[16] }}>
      <>
        {searchReturnedNoResults && (
          <Title isNoMargin size='sm'>
            Sorry, we couldn&apos;t find any results for your search.
            <br />
            <br />
            Please try a less specific search term.
          </Title>
        )}
        {isError && (
          <Title isNoMargin size='sm'>
            Sorry, something went wrong, please try again
          </Title>
        )}
      </>
      <div style={{ display: 'flex', flexDirection: 'column', gap: sp[16] }}>
        {response?.req && (response?.totalCount || 0) > 0 && (
          <Title
            size='sm'
            isNoMargin
            headingType='h2'
          >{`${titleCase(response?.req?.searchTerm || response?.req?.location)} ${careLabel(response?.req?.careType)} (${response?.totalCount})`}</Title>
        )}
        <ResultList
          locationName={locationName}
          items={items}
          variant={variant}
          mapLink={
            (response?.req?.careType === CareType.CareHome &&
              `${caresourcerHomeUrl}/uk/care-map?location=${locationName}`) ||
            (response?.req?.careType === CareType.DementiaCareHome &&
              `${caresourcerHomeUrl}/uk/care-map?location=${locationName}&care_provided%5B%5D=dementia`) ||
            undefined
          }
        />
      </div>
      {!isError && results && !!results?.hasMoreResults && (
        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <GetMoreResultsButton buttonText={buttonText} />
        </div>
      )}
    </Stack>
  );
};

export default CareProviderSearchResults;
